module.exports = __webpack_public_path__ + "static/media/padi-mix.1e801ec8.png";